export class PageNumbers {
  current: number
  total: number
  value: any
  constructor({ currentPage, totalPages }: { currentPage: number; totalPages: number }) {
    this.current = currentPage
    this.total = totalPages
    this.value = []
  }
  getPages() {
    return this.setCenter()
      .filterCenter()
      .includeTreeLeft()
      .includeTreeRight()
      .includeLeftDots()
      .includeRightDots()
      .includeFirstAndLast().value
  }

  setCenter() {
    this.value = [
      this.current - 2,
      this.current - 1,
      this.current,
      this.current + 1,
      this.current + 2,
    ]
    return this
  }
  filterCenter() {
    this.value = this.value.filter((position: number) => position > 1 && position < this.total)
    return this
  }
  includeTreeLeft() {
    if (this.value == 5) {
      this.value = [2].concat(this.value)
    }
    return this
  }
  includeTreeRight() {
    if (this.current == this.total - 4) {
      this.value = this.value.concat([this.total - 1])
    }
    return this
  }
  includeLeftDots() {
    if (this.current > 5) {
      this.value = ['...'].concat(this.value)
    }
    return this
  }
  includeRightDots() {
    if (this.current < this.total - 4) {
      this.value = this.value.concat(['...'])
    }
    return this
  }
  includeFirstAndLast() {
    this.value = [1].concat(this.value).concat(this.total)
    return this
  }
}
